
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.325 17.916a1.79 1.79 0 01-1.498-.799l-2.44-3.462a.75.75 0 011.227-.864l2.45 3.477a.306.306 0 00.261.148.294.294 0 00.236-.119l7.852-9.935a.75.75 0 011.175.93l-7.843 9.923a1.781 1.781 0 01-.423.396 1.78 1.78 0 01-.997.305z"}}),_c('path',{attrs:{"d":"M12 23.999c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-22.5c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z"}})])
          )
        }
      }
    